<template>
    <div>
        <h1>Privacy Policy</h1>

        Effective Date: 2025 January 22
        Last Updated: 2025 January 22

        This Privacy Policy explains how X PLUS North America Corp. ("Company," "we," "our," or "us") collects, uses, and protects information in connection with our private application ("Application"). This Application is strictly for internal use by the Company and X PLUS Company Ltd., and is not accessible to other third parties or external users.
        
        <h2>1. Purpose of the Application</h2>
        The Application is designed for internal business operations and is exclusively used by employees of X PLUS North America Corp. and X PLUS Company Ltd. It is not intended for use by other external parties, including customers, clients, or third-party vendors.
        
        <h2>2. Information We Collect</h2>
        The Application is used to manage internal operations and may process the following types of information:

        <ul>
            <li>Internal business data (e.g., inventory, sales, sales metrics, project details, products).</li>
            <li>Employee data necessary for operational purposes (e.g., user access credentials, activity logs).</li>
        </ul>
        
        <h2>3. Use of Information</h2>
        The information processed by the Application is used solely to:

            Facilitate internal operations.
            Improve efficiency and workflow within the Company.

        <h2>4. Data Sharing</h2>
        The Application is strictly internal. No data processed by the Application is shared with third parties, partners, or external entities.
        
        <h2>5. Data Security</h2>
        We implement appropriate technical and organizational measures to protect the data processed within the Application. This includes:

        <ul>
            <li>Access control limited to authorized employees.</li>
            <li>Encryption and secure storage mechanisms.</li>
            <li>Regular system monitoring and updates to maintain security.</li>
        </ul>
        
        <h2>6. Retention of Data</h2>
        The information processed by the Application is retained only as long as necessary for operational purposes and in accordance with internal Company policies. Data is securely deleted or anonymized when no longer needed.
        
        <h2>7. Employee Responsibilities</h2>
        Authorized employees are responsible for:

        <ul>
            <li>Using the Application only for legitimate business purposes.</li>
            <li>Maintaining the confidentiality of any access credentials.</li>
            <li>Complying with internal policies and procedures.</li>
        </ul>
        
        <h2>8. Changes to this Privacy Policy</h2>
        We may update this Privacy Policy from time to time to reflect changes in our operations or legal requirements. Any updates will be communicated internally and take effect immediately upon posting.

        <h2>9. Contact Information</h2>
        If you have questions about this Privacy Policy or how information is handled within the Application, please contact us at:

        X PLUS North America Corp.
        Email: jeremy.soles@xplus.co.jp
        Address: 103 E Price Rd Suite B, Brownsville TX 78521, United States
    </div>
</template>

<script>
export default{
    mounted(){
        this.$nextTick(()=>{
            const navbar = document.getElementById('Navigationbar');
            if (navbar !== null)
            {
                navbar.remove();
            }
        });
    }
}
</script>